import gql from 'graphql-tag';

export const setFrequentSearchStatusMutation = gql`
    mutation setFrequentSearchStatusMutation($id: ID!, $status: FrequentSearchStatus!) {
        results: frequentSearchSetStatus(id: $id, newStatus: $status) {
            id
            status
        }
    }
`;